import { Component } from '@angular/core';

@Component({
  selector: 'empathy-essay-description',
  templateUrl: 'essay-description.component.html',
  styleUrls: ['./essay-description.component.scss']
})
export class EssayDescriptionComponent {}
